import { render, staticRenderFns } from "./ComponentPrep2.vue?vue&type=template&id=e7cbf7fe&scoped=true&"
import script from "./ComponentPrep2.vue?vue&type=script&lang=js&"
export * from "./ComponentPrep2.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPrep2.vue?vue&type=style&index=0&id=e7cbf7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cbf7fe",
  null
  
)

export default component.exports